module.exports = __webpack_public_path__ + "img/step3cards.953207d.png";